import React from 'react';
import { Box, NavLink, Text, Title } from '@mantine/core';
import { Brain, Home, Puzzle, Compass, Apple, FlaskConical, Bookmark } from 'lucide-react';
interface SidebarProps {
  activeItem: string;
  onNavigate: (item: string) => void;
}
export function Sidebar({
  activeItem,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    label: 'Home',
    value: 'home',
    icon: <Home size={18} className="text-white" data-id="element-514" />
  }, {
    label: 'Vector',
    value: 'vector',
    icon: <Apple size={18} className="text-white" data-id="element-515" />
  }, {
    label: 'Build',
    value: 'build',
    icon: <Puzzle size={18} className="text-white" data-id="element-516" />
  }, {
    label: 'Explore',
    value: 'explore',
    icon: <Compass size={18} className="text-white" data-id="element-517" />
  }, {
    label: 'Saved',
    value: 'saved',
    icon: <Bookmark size={18} className="text-white" data-id="element-518" />
  }, {
    label: 'Methodology',
    value: 'methodology',
    icon: <FlaskConical size={18} className="text-white" data-id="element-519" />
  }];
  return <Box className="h-screen bg-slate-700 shadow-sm p-4 flex flex-col" data-id="element-520">
      <div className="flex items-center mb-8 pl-2" data-id="element-521">
        <Brain className="text-white mr-2" size={24} data-id="element-522" />
        <Title order={3} className="text-xl font-bold text-white" data-id="element-523">
          Nutrivector
        </Title>
      </div>
      <div className="space-y-1" data-id="element-524">
        {navItems.map(item => <NavLink key={item.value} active={activeItem === item.value} label={<span className="text-white" data-id="element-526">{item.label}</span>} leftSection={item.icon} onClick={() => onNavigate(item.value)} className={`rounded-md ${activeItem === item.value ? 'bg-emerald-700' : 'hover:bg-slate-600'}`} data-id="element-525" />)}
      </div>
    </Box>;
}